module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/5@2x_53199e1eed23ddae4430c5e98835c4e9.png";